import { ChangeDetectorRef, Component, Input, Output } from '@angular/core';
import { from } from 'rxjs';
import { AgGridAngular } from 'ag-grid-angular';
import { GridOptions } from "ag-grid-community";
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { UserManagement } from '../../pages/user_management/user_management';
import { AlertController, Events, ModalController, ToastController } from 'ionic-angular';

const defautSharePath = 0;
const NO_INDEX = -1;
const WATCH_ENABLE = 1;
const WATCH_DISABLE = 2;
const OBJLEN = 0;
declare var jQuery;
@Component({
  selector: 'folder-security-property',
  templateUrl: 'folder-security-property.html'
})
export class FolderSecurityPropertyComponent {
  @Input() objShareInfo: any;
  @Input() screenProps: any = [];
  @Input() objCurrentFolder: any;
  rowData: any = [];
  columnDefs: any = [];
  defaultColDef: any; //Default Properties to be handle in ag grid 
  gridOptions: any = { 'filterChange': true }; //Container to store grid properties and events
  gridApi: any;//GridOptions api store
  gridColumnApi: any;//Ag grid column APi data
  rowSelection: any;   //Single selection row/Multiple select row
  text: string;
  objSelectedUser: any = [];
  objUserId: any = [];
  objFolderUser: any = [];
  acceessType: any = "private";
  receiverEmailId: any = [];
  userSubmitText: any = 'Submit';
  removeUserList: boolean = true;
  accessUser = [];
  objAllowUserControl: any = 'Edit Access'
  objShareInformation: any = [];
  removeButtonEnable: boolean = false;
  objAllowUserControlIsDisable: boolean = true;
  objAllowUserControlIsChecked: boolean = false;
  objAccCurrentFolder: any = {}
  // accessId: any = '';
  // watchFlag: any;
  objAllowWatchTabIsChecked: boolean = false;
  watchuserlist: any = [];
  // watchuserEmaillist: any = [];
  // watchuserEmailAccessList: any = [];
  // removeWatchUserList: any = [];
  objWashPushArray: any = [];
  // watchMessageFlag: any;
  ShareID: any;
  userDetails: any = [];
  accessList = [];
  rowIndex: any;
  prevIndex:any;
  userList: any = [];
  constructor(public configApiService: ConfigApiServiceProvider,private cdr: ChangeDetectorRef, private alertCtrl: AlertController, public events: Events, private toastController: ToastController, public driveService: DriveServiceProvider, public configServiceProvider: ConfigureServiceProvider, private modal: ModalController) {
  }

  ngOnInit() {
    this.objCurrentFolder = this.driveService.clone(this.objCurrentFolder);
    this.objAccCurrentFolder = JSON.stringify(this.objCurrentFolder)
    this.driveService.getShareUserList(this.objCurrentFolder, this.configServiceProvider.getLoginUserID(), this.pullsubmitSuccess);
    this.getWatchList();
  }

  openUSerListPopup() {
    jQuery('.cursor').removeClass('activeRow');
    this.objSelectedUser = [];
    this.objFolderUser.forEach(ele => {
      if(ele.email_id){
        this.userList.push(ele.email_id)
      }
  })
    var modalPage = this.modal.create(UserManagement, { "folderPropertiesUser": true, 'shareUsers': this.userList, 'accessList': this.objShareInformation }, { cssClass: "manage-account", showBackdrop: true, enableBackdropDismiss: false });
    modalPage.present();
    modalPage.onDidDismiss(data => {
      if (Object.keys(data).length != 0) {
        this.objFolderUser = this.driveService.clone(data.accessUser)
        this.removeUserList = data.removeUser['length'] > 0 ? true : false;
        this.objSelectedUser = data.removeUser;
        this.objShareInformation = data.accessUser;
      }
    })
  }

  selectedUserRow(e, i, user) {
    this.removeButtonEnable = true;
    // if(this.prevIndex != undefined){
    //   this.objFolderUser[this.prevIndex]['rowSelect'] = false;
    // }
    // if (this.rowIndex != undefined) {
    //   document.getElementById('selectedUser' + this.rowIndex).classList.remove('activeRow');
    //   document.getElementById('editAccess' + this.rowIndex).classList.add('editChecked')
    //   document.getElementById('watchAccess' + this.rowIndex).classList.add('watchChecked')
    //   let userArrIndex = this.objSelectedUser.findIndex(selectedUser => selectedUser.user == user);
    //   this.objSelectedUser.splice(userArrIndex, 1);
    //   this.objUserId.splice(userArrIndex, 1);
    // }
    if (e.checked == true) {
      let userArrIndex = this.objSelectedUser.findIndex(selectedUser => selectedUser.user == user);
        this.objSelectedUser.splice(userArrIndex, 1);
        this.objUserId.splice(userArrIndex, 1);
      document.getElementById('selectedUser' + i).classList.add('activeRow');
      document.getElementById('editAccess' + i).classList.remove('editChecked')
      document.getElementById('watchAccess' + i).classList.remove('watchChecked')
      this.rowIndex = i;
      this.objSelectedUser.push(user);
    }else{
      this.objFolderUser[i]['rowSelect'] = false;
      document.getElementById('selectedUser' + i).classList.remove('activeRow');
      document.getElementById('editAccess' + i).classList.add('editChecked')
      document.getElementById('watchAccess' + i).classList.add('watchChecked')
    }

    if (this.receiverEmailId.length != 0) {
      let receivemailIdx = this.receiverEmailId.findIndex(item => item == user.email_id)
      if (receivemailIdx != -1) {
        this.removeButtonEnable = true;
      } else {
        this.removeButtonEnable = false;
      }
    } else {
      this.removeButtonEnable = false;
    }
    if (this.objSelectedUser['length'] > 0) {
      let Idx = this.objShareInformation.findIndex(item => item['email_id'] == user.email_id);
      this.objFolderUser[i]['IsReadOnlyShare'] = this.objShareInformation[Idx]['IsReadOnlyShare'] == 'YES' ? false : true;
      this.objFolderUser[i]['IsWatchAcessFlag'] = this.objShareInformation[Idx]['IsWatchAcessFlag'] == 'YES' ? true : false;
      this.removeButtonEnable = true;
    }
    this.prevIndex = i;
  }

  getWatchList() {
    if (this.configApiService.driveApi.pullWatchTab) {
      let objData = Object.assign({}, this.configApiService.driveApi.pullWatchTab.params, { 'userid': this.configServiceProvider.getLoginUserID(), "folderID": this.objCurrentFolder['folder_id'] })
      this.configApiService.pullRequest(objData, (respData) => {
        if (respData.length > 0) {
          respData.forEach(element => {
            this.watchuserlist.push({ email: element.email_id, watchTag: element.watchFlag, accessId: element.accessID, userid: element.Reciever_user_id });
          })
        }
      })
    }
  }

  pullsubmitSuccess = (responsedata => {
    if (responsedata.length != 0) {
      let accessList = {};
      var acc = []
      this.ShareID = responsedata[0]['ShareID'];
      this.objShareInfo = JSON.parse(responsedata[0]["SharedInfo"]);
      this.objShareInformation = JSON.parse(responsedata[0]['ReceiverEmail']);
      this.objShareInformation.forEach(item => {
        this.receiverEmailId.push(item['email_id']);
        accessList = {
          'email_id': item['email_id'],
        }
        this.objFolderUser.push(accessList)
      })
      this.acceessType = responsedata[0]["AccessType"];
    }
  })



  clickedRow(e, i) {
    e['checked'] = true;
    if(this.prevIndex != undefined){
      this.objFolderUser[this.prevIndex]['rowSelect'] = false;
    }
    this.objFolderUser[i]['rowSelect'] = true;
    this.prevIndex = i;
    this.selectedUserRow(e, i, this.objFolderUser[i])
  }



  onSubmit(text) {
    this.userSubmitText = text;
    if (this.objShareInformation.length != 0) {
      if (this.userSubmitText == 'Submit') {
        this.pushShareCopy();
      } else {
        this.updateUser();
      }
    }
  }


  pushShareCopy() {
    let shareFolder = JSON.parse(JSON.stringify(this.objShareInfo))
    this.objFolderUser.forEach((user, i) => {
      let accessIdx = this.objShareInformation.findIndex(item => item['email_id'] == user.email_id);
      if (accessIdx != -1) {
        shareFolder['sharedFolder']['IsReadOnlyShare'] = this.objShareInformation[accessIdx]["IsReadOnlyShare"];
      }
    })
    shareFolder['sharedFolder']['author'] = this.configServiceProvider.getLoginData();
    this.driveService.shareInfoFolder(shareFolder['sharedFolder'], shareFolder, (_respData) => {
      this.objShareInfo.ShareID = _respData;
      this.ShareID = _respData;
      this.pushShareUser();
    });
  }

  pushShareUser() {
    let pushParams = {
      "SharedInfo": this.objShareInfo,
      "ShareType": "Folder",
      "TemplateID": this.screenProps['id'],
      "ReceiverEmail": JSON.stringify(this.objShareInformation),
      "TemplateName": this.screenProps['templateName'],
      "AccessType": this.acceessType,
      "UserFolder": this.objCurrentFolder['folder_id'],
      "userid": this.configServiceProvider.getLoginUserID(),
      "ShareID": this.ShareID != undefined ? this.ShareID : ''
    }
    let pushObjData = Object.assign({}, this.configApiService.driveApi.pushLinkShareUser.params, pushParams);
    this.configApiService.pushRequest(pushObjData, this.submitSuccess);
  }

  submitSuccess = (responsedata => {
    this.ShareID = responsedata['ShareID'];
    if (this.userSubmitText == 'Submit') {
      this.shareFolder()
    }
  })


  shareFolder() {
    let objUserFolder = [];
    if (this.receiverEmailId.length != 0) {
      objUserFolder = this.objFolderUser.filter(item => {
        if (!this.receiverEmailId.includes(item.email_id)) {
          return item.email_id
        }
      })
    } else {
      objUserFolder = this.objFolderUser;
    }
    this.pushFolderToShare(objUserFolder);
  }

  pushFolderToShare(objUserFolder) {
    this.objShareInfo['sharedFolder']['path'] = []
    this.objShareInfo['sharedFolder']['path'].push(defautSharePath);
    this.objShareInfo['sharedFolder']['author'] = this.configServiceProvider.getLoginData();
    objUserFolder.forEach((user, i) => {
      let userIdx = this.driveService.ObjCurrentAppUsers.findIndex(users => users.email_id == user.email_id);
      let appuser = this.driveService.ObjCurrentAppUsers[userIdx];
      if (this.objShareInformation[i]['IsWatchAcessFlag'] == 'YES') {
        this.watchuserlist.push({ email: user.email_id, watchTag: WATCH_ENABLE, accessId: '', userid: appuser['app_user_id'] });
      }
      let pushFolderData = {
        appCode: appuser['app_code'],
        folder: this.objShareInfo['sharedFolder'],
        userid: appuser['app_user_id'],
        shareID: this.ShareID,
        action: "sharePaste"
      }
      this.driveService.storeTodrive(pushFolderData, (respData) => {
        if (objUserFolder.length == i + 1) {
          if (this.watchuserlist.length > OBJLEN) {
            this.onPostWatchApi();
          }
          let toast = this.toastController.create({
            message: "Folder Move to drive successfully.",
            duration: this.configApiService.toastDuration
          });
          toast.present();
          this.closeFolderPropertyScreen();
        }
      });
    })
  }



  getAccessType(event, user, i) {
    this.removeButtonEnable = true;
    this.userSubmitText = this.receiverEmailId.length != 0 ? 'Update' : 'Submit';
    let userIdx = this.objFolderUser.findIndex(item => item.email_id == user.email_id)
    this.objSelectedUser.forEach((user, i) => {
      if (this.receiverEmailId.length != 0) {
        let receivemailIdx = this.receiverEmailId.findIndex(item => item == user.email_id)
        if (receivemailIdx != -1) {
          this.removeButtonEnable = false;
        } else {
          this.removeButtonEnable = true;
        }
      } else {
        this.removeButtonEnable = true;
      }
      if (this.removeButtonEnable == false) {
        this.userSubmitText = 'Update';
      } else {
        this.userSubmitText = 'Submit';
      }
      let accessIdx = this.objShareInformation.findIndex(item => item['email_id'] == user.email_id);
      if (userIdx != NO_INDEX) {
        this.objFolderUser[userIdx]["IsReadOnlyShare"] = event.checked;
      }
      if (accessIdx != NO_INDEX) {
        this.objShareInformation[accessIdx]["IsReadOnlyShare"] = event.checked ? 'NO' : 'YES';
        this.objShareInfo['sharedFolder']['IsReadOnlyShare'] = this.objShareInformation[accessIdx]["IsReadOnlyShare"]
        delete this.objShareInformation[accessIdx]['rowSelect']
      }
    });
  }

  getWatchAccess(toggle, user) {
    this.removeButtonEnable = true;
    this.userSubmitText = this.watchuserlist.length != 0 ? 'Update' : 'Submit';
    this.objSelectedUser.forEach((user, i) => {
      if (this.receiverEmailId.length != 0) {
        let receivemailIdx = this.receiverEmailId.findIndex(item => item == user.email_id)
        if (receivemailIdx != -1) {
          this.removeButtonEnable = false;
        } else {
          this.removeButtonEnable = true;
        }
      } else {
        this.removeButtonEnable = true;
      }
      if (this.removeButtonEnable == false) {
        this.userSubmitText = 'Update';
      } else {
        this.userSubmitText = 'Submit';
      }
      this.objFolderUser[i]["IsWatchAcessFlag"] = toggle.checked;
      let watchAccessIdx = this.objShareInformation.findIndex(item => item['email_id'] == user.email_id);
      let watchIdx = this.watchuserlist.findIndex(item => item['email'] == user.email_id);
      if (watchIdx != -1) {
        this.watchuserlist[watchIdx]["watchTag"] = toggle.checked ? WATCH_ENABLE : WATCH_DISABLE;
      }
      if (watchAccessIdx != -1) {
        this.objShareInformation[watchAccessIdx]["IsWatchAcessFlag"] = toggle.checked ? 'YES' : 'NO';
         this.objShareInfo['sharedFolder']['IsWatchAcessFlag'] = this.objShareInformation[watchAccessIdx]["IsWatchAcessFlag"]
      }
    });
  }

  updateUser() {
    this.objShareInfo['sharedFolder']['path'] = []
    this.objShareInfo['sharedFolder']['path'].push(defautSharePath);
    this.objShareInfo['sharedFolder']['author'] = this.configServiceProvider.getLoginData();
    this.objSelectedUser.forEach((user, i) => {
      let accessIdx = this.objShareInformation.findIndex(item => item['email_id'] == user.email_id);
      this.pushShareCopy();
      let userIdx = this.driveService.ObjCurrentAppUsers.findIndex(users => users.email_id == user.email_id);
      let appuser = this.driveService.ObjCurrentAppUsers[userIdx];
      let pushFolderData = {
        appCode: appuser['app_code'],
        folder: this.objShareInfo['sharedFolder'],
        userid: appuser['app_user_id'],
        action: 'update',
      }
      this.driveService.storeTodrive(pushFolderData, (respData) => {
        if (this.objSelectedUser.length == i + 1) {
          if (this.watchuserlist.length > OBJLEN) {
            this.onPostWatchApi();
          }
          let toast = this.toastController.create({
            message: "Folder Update successfully.",
            duration: this.configApiService.toastDuration
          });
          toast.present();
          this.objSelectedUser = [];
          this.objAllowUserControlIsDisable = false;
          this.objAllowUserControlIsChecked = false;
          // this.objAllowWatchTabIsChecked = false;
          this.userSubmitText = 'Submit'
          this.closeFolderPropertyScreen();
        }
      });
    })
  }

  removeSubmit() {
    this.removeUserList = false;
    let alert = this.alertCtrl.create({
      title: 'Are you sure, want to remove the share Users?',
      buttons: [
        {
          text: 'NO',
          role: 'cancel'
        },
        {
          text: 'YES',
          handler: data => {
            this.removeUser();
          }
        }
      ]
    });
    alert.present();
  }


  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  removeUser() {
    let objUserFolder = [];
    if (this.objSelectedUser.length != 0) {
      objUserFolder = this.objFolderUser.filter(item => this.objSelectedUser.includes(item))
      this.objFolderUser = this.objFolderUser.filter(item => !this.objSelectedUser.includes(item))
    } else {
      objUserFolder = this.objFolderUser;
    }
    var Idx;
    this.objSelectedUser.forEach(user => {
      Idx = this.objShareInformation.findIndex(item2 => item2['email_id'] == user.email_id);
      if (Idx != NO_INDEX) {
        this.objShareInformation.splice(Idx, 1)
      }
    })
    if (this.removeUserList == false) {
      this.pushShareUser();
    }
    this.removeFolder(Idx);
  }

  removeFolder(accessIdx) {
    this.objShareInfo['sharedFolder']['path'] = []
    this.objShareInfo['sharedFolder']['path'].push(defautSharePath);
    this.objShareInfo['sharedFolder']['author'] = this.configServiceProvider.getLoginData();
    this.objSelectedUser.forEach((email_ID, i) => {
      let watchIdx = this.watchuserlist.findIndex(users => users.email_id == email_ID.email_id);
      if (watchIdx != NO_INDEX) {
        this.watchuserlist[watchIdx].watchTag = WATCH_DISABLE;
        this.objWashPushArray.push(this.watchuserlist[watchIdx])
      }
      let userIdx = this.driveService.ObjCurrentAppUsers.findIndex(users => users.email_id == email_ID.email_id);
      let appuser = this.driveService.ObjCurrentAppUsers[userIdx];
      this.watchuserlist.push({ email: email_ID, watchTag: WATCH_ENABLE, accessId: '', userid: appuser['app_user_id'] });
      let pushFolderData = {
        appCode: appuser['app_code'],
        folder: this.objShareInfo['sharedFolder'],
        userid: appuser['app_user_id'],
        action: 'delete',
      }
      this.driveService.storeTodrive(pushFolderData, (respData) => {
        if (this.objSelectedUser.length == i + 1) {
          this.watchuserlist = this.objWashPushArray;
          if (this.watchuserlist.length > OBJLEN) {
            this.onPostWatchApi();
          }
          let toast = this.toastController.create({
            message: "Folder removed for selectedUsers.",
            duration: this.configApiService.toastDuration
          });
          toast.present();
          this.objSelectedUser = [];
          this.userSubmitText = 'Submit';
          this.closeFolderPropertyScreen();
        }
      });
    })
  }

  onPostWatchApi() {
    let objCurrentFolder = JSON.parse(this.objAccCurrentFolder)
    objCurrentFolder['files'] = [];
    this.driveService.pushWatchAccessApi(this.watchuserlist, this.screenProps, objCurrentFolder, this.configServiceProvider.getLoginUserID())
  }

  onSubmitCancel() {
    this.closeFolderPropertyScreen();
  }

  closeFolderPropertyScreen() {
    this.driveService.broadcastInfo({ src: 'drive-main', event: 'folderPropertyClose', status: true });
  }
}



// WEBPACK FOOTER //
// ./src/components/folder-security-property/folder-security-property.ts